import { FC } from 'react';

import { useBusinessPlanOptions } from 'constants/businessPlan';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';
import { v4 as uuidV4 } from 'uuid';

import { BusinessPlanButton } from '../CreateBusinessPlanButton/CreateBusinessPlanButton';

interface IBusinessPlanButtonListProps {
  showAvailablePlansCount?: boolean;
}

export const BusinessPlanButtonList: FC<IBusinessPlanButtonListProps> = ({ showAvailablePlansCount = false }) => {
  const userSubscription = useUserSubscriptionStore(getUserSubscription);
  const businessPlanOptions = useBusinessPlanOptions();

  return (
    <>
      {businessPlanOptions.map((option) => (
        <BusinessPlanButton
          key={uuidV4()}
          {...option}
          userSubscription={userSubscription?.currentSubscription}
          showAvailablePlansCount={showAvailablePlansCount}
        />
      ))}
    </>
  );
};
